export default __webpack_public_path__ + "static/media/20.684bcd33.jpg";